import { useCallback, useEffect, useState } from 'react';

import { IconAlertTriangle, IconX } from '@tabler/icons-react';

import Button from '@lotlinx-aws/sparky-component-library/Sparky/Button';
import Flex from '@lotlinx-aws/sparky-component-library/Sparky/Flex';
import IconButton from '@lotlinx-aws/sparky-component-library/Sparky/IconButton';
import Modal from '@lotlinx-aws/sparky-component-library/Sparky/Modal';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';
import { IconAlertTriangleFilled } from '@tabler/icons-react';

import { asAPIError } from 'api/utils/APIError';
import { ErrorCode } from 'api/utils/ErrorCode';
import { ERROR_MODAL_EVENT } from 'store/errorModalEvent';

import styles from './ErrorModal.module.scss';
import Message from '@lotlinx-aws/sparky-component-library/Sparky/Message';

export default function ErrorModal() {
  const [error, setError] = useState<Error | null>(null);

  const handleEvent = useCallback((e: Event) => {
    const customEvent = e as CustomEvent<Error>;
    setError(customEvent.detail);
  }, []);

  useEffect(() => {
    window.addEventListener(ERROR_MODAL_EVENT, handleEvent);
    return () => window.removeEventListener(ERROR_MODAL_EVENT, handleEvent);
  }, [handleEvent]);

  const dismiss = () => setError(null);

  if (!error) return null;

  const apiError = asAPIError(error);
  const requestId = apiError?.requestId;
  const heading =
    apiError?.message.toLowerCase().includes('dealer') &&
    apiError?.message.toLowerCase().includes('not found')
      ? 'Error: Invalid Dealer ID'
      : 'Error';

  return (
    <Modal isOpen={!!error} onDismiss={dismiss} aria-label='Error Details'>
      <div className={styles.errorModal} tabIndex={-1} ref={(el) => el?.focus()}>
        <Flex width='100%' justifyContent='space-between'>
          <Flex margin='4px 0 8px' alignItems='center' gap='8px'>
            <IconAlertTriangleFilled color='var(--status-error)' size={20} />
            <Text type='heading-03' color='red'>
              {heading}
            </Text>
          </Flex>
          <IconButton aria-label='close' onClick={dismiss}>
            <IconX />
          </IconButton>
        </Flex>
        <Flex margin='0 12px 16px 30px'>
          <Text type='body-01'>{error.message}</Text>
        </Flex>
        {requestId && (
          <Text size='12' className={styles.requestId}>
            Reference ID: {requestId}
          </Text>
        )}
      </div>
    </Modal>
  );
}
